import CustomTabs from '../../../components/CustomTabs';
import { HiOutlineShare, HiOutlineListBullet } from "react-icons/hi2";
import { OrgChartTab } from './tabs/OrganisationChartsTab';
import { OrgListTab } from './tabs/OrganisationListsTab';

export const ProfileOrgTab = () => {
  return (
    <>

      <hr></hr>
      <CustomTabs
        variant="segmented"
        tabs={[
          {
            label: (
              <>
                <HiOutlineShare size={16} />
                Chart
              </>
            ),
            content: <OrgChartTab />,
          },
          {
            label: (
              <>
                <HiOutlineListBullet size={16} />
                List
              </>
            ),
            content: <OrgListTab />,
          },
        ]}
        activeTabIndex={0}
      />
    </>
  );
};
